"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function StepLabel(props) {
    return (react_1.default.createElement(styles_1.MainContainer, { active: props.active, color: props.color }, props.children));
}
exports.default = StepLabel;
//# sourceMappingURL=index.js.map